import { bus } from '@/consts'
export default {
  name: 'LightSources',
  template: '#light-sources-template',
  data () {
    return {
      bottomLightActive: false
    }
  },
  computed: {
    bottomClasses () {
      return {
        'light-sources-img--bottom--active': this.bottomLightActive
      }
    }
  },
  mounted () {
    bus.$on('activateBottomLight', () => {
      this.bottomLightActive = true
    })
    bus.$on('deactivateBottomLight', () => {
      this.bottomLightActive = false
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/LightSources.js